import React, { FC, useEffect } from 'react';
import classNames from 'classnames';
import { RouteComponentProps } from 'react-router';
import styles from './assets/internal-edit-screen.module.scss';
import Loader from 'src/components/Loader';
import RoleLayout from 'src/components/layout/RoleLayout';
import Form from '../../components/InternalForm';
import { IInternal } from 'src/types/internal';
import { IProvider } from '../../../../../../types/provider';
import { Paginated } from '../../../../../../services/api-handlers/pagination';
import { QueryParams } from '../../../../../../types/grid';
import Breadcrumbs from '../../../../../../components/Breadcrumbs';
import { routes } from '../../../../../../navigation';

export interface StateProps {
    internal: IInternal | null;
    inProgress: boolean;
    providers: Paginated<IProvider>;
}

export interface DispatchProps {
    getData: (id: string | number) => void;
    getProviders: (params: QueryParams) => void;
}

interface RouteParams {
    id: string;
}

export interface OwnProps extends RouteComponentProps<RouteParams> {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const InternalEditScreen: FC<Props> = (props: Props) => {
    const {
        internal,
        inProgress,
        match: {
            params: { id },
        },
        getData,
    } = props;
    useEffect(() => {
        props.getProviders({
            page: 1,
            itemsPerPage: 9000,
        });
        // eslint-disable-next-line
    }, []);
    useEffect(() => {
        if (!internal || internal.id !== id) {
            getData(id);
        }
        // eslint-disable-next-line
    }, [getData, id]);

    if (!internal || inProgress) {
        return <Loader />;
    }
    const { providers } = props;
    return (
        <RoleLayout>
            <Breadcrumbs
                items={[
                    { name: 'INTERNALS', path: routes.INTERNALS_LIST },
                    { name: `EDIT ${internal?.id ? internal?.id : ''}`, path: '' },
                ]}
            />
            <div className={classNames(styles.editWrap)}>
                <Form
                    providers={providers.list}
                    initialValues={{
                        ...internal,
                        providerDropDown: { value: internal.provider?.id, label: `${internal.provider?.fullName}` },
                    }}
                />
            </div>
        </RoleLayout>
    );
};
export default InternalEditScreen;
